let
    team = {
        mentors:[
            {
                post: "Mentor",
                name: 'Paras Gupta',
                id: 'paras',
                linkedin:'https://www.linkedin.com/in/paras-gupta-b6a63284/',
                mail:'Paras.Gupta@mech.iitd.ac.in',
                dept: 'Department of Mechanical Engg',
            },
            {
                post: "Mentor",
                name: 'Aman Gupta',
                id: 'aman', 
                dept: 'Textile Technology',
                hostel:'Vindhyachal',
                linkedin:'https://www.linkedin.com/in/aman-gupta-67648b251/',
                mail:'tt1222151@iitd.ac.in'
            }
        ],
        executives:
            [
            {
                post: "Tech Executive",
                name: "Sthitapragyan Mallick",
                id: "spm", 
                linkedin:'https://www.linkedin.com/in/sthitapragyan-mallick-192a81284/',
                mail:'sthitapragyanmallick@outlook.com',
                dept: 'Engineering Physics',
                hostel:'Girnar'
            },
            {
                post: "Core Executive",
                name: "Garv Patidar",
                id: "gp",
                linkedin:'https://www.linkedin.com/in/garv-patidar-b3671b281', 
                mail:'garvpatidarkota@gmail.com',
                dept: 'Electrical Engineering',
                hostel:'Shivalik'
                
            },
            {
                post: "Core Executive",
                name: "Abhishek Arnav",
                id: "abhi",
                linkedin:'https://www.linkedin.com/in/abhishek-arnav-1999a0291/',
                mail:'abhishek200608@gmail.com',
                dept: 'Materials Sc Engg',
                hostel: 'Girnar'
            },
            {
                post: "Tech Executive",
                name: "Siri Dharan Kataru",
                id: "siri",
                linkedin:'https://www.linkedin.com/in/siri-dharan-kataru-ab70a2284/',
                mail:'katarusiridharan@gmail.com',
                dept: 'Computer Science',
                hostel: 'Shivalik'
            },
            {
                name: "Jayesh Narayanan",
                id: "jn",
                linkedin:'https://www.linkedin.com/in/jayesh-narayanan-51b51b290/',
                mail:'jayeshny@gmail.com',
                dept: 'Electrical Engineering',
                hostel: 'Udaigiri'
            },
            // {
            //     post: "Tech Executive",
            //     name: "Avani Sengupta",
            //     id: "avani",
            //     linkedin:'https://www.linkedin.com/in/avani-sengupta-a54699303',
            //     mail:'avani.sengupta@gmail.com',
            //     dept: 'Biotechnology',
            //     hostel: 'Kailash'
            // },
            // {
            //     post: "Tech Executive",
            //     name: "Sreelakshmi S",
            //     id: "srilaxmi",
            //     linkedin:'https://www.linkedin.com/in/srilaxmi-sunil-02a00a27a',
            //     mail:'srilaxmisunil18@gmail.com',
            //     dept: 'Engineering Physics',
            //     hostel: 'Kailash'
            // },
            // {
            //     post: "Tech Executive",
            //     name: "Tanvi Nagar",
            //     id: "tanvi",
            //     linkedin:'https://www.linkedin.com/in/tanvi-nagar-b609652a3',
            //     mail:'tanvingr@gmail.com',
            //     dept: 'Production Engg',
            //     hostel: 'Kailash'
            // },
            
            ]

    }

export default team
